import {TextField as T} from "@mui/material";
import {styled} from "@mui/material/styles";

const TextField = styled(T)({
    width: "100%",
    '& label.Mui-focused': {
        color: 'rgb(0,174,239)',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'rgb(0,174,239)',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'rgb(0,174,239)',
        },
        '&:hover fieldset': {
            borderColor: 'rgb(0,174,239)',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'rgb(0,174,239)',
        },
    },
});

const TextField2 = styled(T)({
    '& input:valid + fieldset': {
        borderColor: 'green',
        borderWidth: 2,
    },
    '& input:invalid + fieldset': {
        borderColor: 'red',
        borderWidth: 2,
    },
    '& input:valid:focus + fieldset': {
        borderLeftWidth: 6,
        padding: '4px !important', // override inline-style
    },
});

export {TextField, TextField2};